import React, { Component, } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";


class LayoutClass extends Component {
  state = { assetsLoaded: false };

  componentDidMount() {

    const cssFiles = [
      "/assets/frontend/css/A.bootstrap-5.3.2.min.css%2bjquery.mCustomScrollbar.min.css%2bfont-awesome.min.css%2bstyle.css%2cMcc.VVyuQMAZjX.css.pagespeed.cf.__alNoXQVI.css",
      "/assets/frontend/css/A.orange.css.pagespeed.cf.i4NKouKWX7.css",
      "/assets/frontend/css/A.responsive.css%2bcustom.css%2bowl.carousel.css%2bowl.theme.css%2bflexslider.css%2bdatepicker.css%2bmagnific-popup.css%2cMcc.VTjjOaSJRq.css.pagespeed.cf.K8WkdAKYTj.css",
      "/assets/frontend/css/A.responsive.css%2bcustom.css%2bdatepicker.css%2bslick.css%2bslick-theme.css%2cMcc.EvfTy5mt5V.css.pagespeed.cf.tgZj8MAvWx.css",
      "/assets/frontend/font-override.css"
    ];

    const scriptFiles = [
      // "/assets/frontend/js/popper.min.js.pagespeed.jm.xAgiSZEJtL.js",
      // "/assets/frontend/js/jquery.magnific-popup.min.js%2bjquery.mCustomScrollbar.concat.min.js.pagespeed.jc.tHkHXxV1O5.js",
      // "/assets/frontend/js/bootstrap-5.3.2.min.js.pagespeed.ce.9j373MZJ8T.js",
      // "/assets/frontend/js/jquery.flexslider.js%2bbootstrap-datepicker.js.pagespeed.jc.XRDbv_prNr.js",
      // "/assets/frontend/js/owl.carousel.min.js%2bcustom-navigation.js%2bcustom-flex.js%2bcustom-owl.js%2bcustom-date-picker.js%2bcustom-video.js%2bpopup-ad.js.pagespeed.jc.GW6DaQ9Dgs.js",
      // "/assets/frontend/js/slick.min.js%2bcustom-navigation.js%2bcustom-date-picker.js%2bcustom-slick.js%2bjquery.validate.js.pagespeed.jc.yWvsUUKtve.js",
    ];

    Promise.all([
      this.loadCSS(cssFiles),
      this.loadScripts(scriptFiles),
    ]).then(() => {
      this.setState({ assetsLoaded: true });
      window.dispatchEvent(new Event("react:pageRendered"));
    });
    
  }

  loadCSS(files) {
    return Promise.all(
      files.map(
        (href) =>
          new Promise((resolve) => {
            if (document.querySelector(`link[href="${href}"]`)) return resolve();

            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
          })
      )
    );
  }

  loadScripts(files) {
    return Promise.all(
      files.map(
        (src) =>
          new Promise((resolve) => {
            if (document.querySelector(`script[src="${src}"]`)) return resolve();

            const script = document.createElement("script");
            script.src = src;
            script.async = false;
            script.onload = resolve;
            script.onerror = resolve;
            document.body.appendChild(script);
          })
      )
    );
  }

  render() {
    return this.props.children;
  }
}

function LayoutWrapper() {
  
  const location = useLocation();
  const hideSearchResultMobile = location.pathname.startsWith("/searchresultmobile");
  const hideFooter = location.pathname.startsWith("/chat");
  const hideProfile = location.pathname.startsWith("/profile");
  const hideMyListing = location.pathname.startsWith("/mylisting");
  const hideBooking = location.pathname.startsWith("/booking");
  const hideHomesearchbar = location.pathname.startsWith("/homesearchbar");
  const hideListingmobile = location.pathname.startsWith("/listingmobile");
  const hideReservation = location.pathname.startsWith("/reservation");
  const hideCalendar = location.pathname.startsWith("/calendar");

  return (
    <LayoutClass>
      <Header />
      <main>
        <Outlet />
      </main>
      {!hideCalendar && !hideReservation && !hideListingmobile && !hideFooter && !hideBooking && !hideProfile && !hideMyListing && !hideHomesearchbar && !hideSearchResultMobile && <Footer />}
    </LayoutClass>
  );
}

export default LayoutWrapper;
